import { ValetPriceField } from './billing-form-fields.js';
import type { BillingFlags } from './types.js';

/**
 * NFS-e (#527): só a mensalidade do módulo. A taxa de cada nota o Asaas
 * desconta da subconta de Recebimentos do estacionamento.
 */
export const NfsePricingSection = ({
  pricing,
  disabled,
  onSave,
}: {
  pricing: BillingFlags['nfsePricing'];
  disabled: boolean;
  onSave: (patch: { nfsePriceCents: number }) => void;
}) => (
  <div className="border-t border-border pt-4">
    <p className="mb-2 text-sm font-medium">Nota fiscal (NFS-e) — mensalidade</p>
    <p className="mb-3 text-xs text-muted-fg">
      A taxa de cada nota não entra na fatura: o Asaas desconta direto da conta de Recebimentos do
      estacionamento.
    </p>
    <ValetPriceField
      label="Mensalidade do módulo"
      valueCents={pricing?.priceCents ?? 2900}
      disabled={disabled}
      onSave={(cents) => onSave({ nfsePriceCents: cents })}
    />
  </div>
);
